import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from 'store/client/authStore'

export default function ProtectedRoutes() {
  const { user } = useAuth()
  return user ? <Outlet /> : <Navigate to="/girisyap" replace />
}
